import React from 'react'
import { Spacer } from 'components/Layout';
import { BREAKPOINTS } from 'global-constants';
import { useMediaQuery } from 'hooks/useMediaquery';
import useOpen from 'hooks/useOpen';
import { useTranslation } from 'react-i18next';
import CategoryBranch from '../../../components/CategoryBranch/CategoryBranch';
import { Category } from 'generated/gql/gql';
import CategoryPickerModalDesktop from './components/desktop/CategoryPicker.modal';
import CategoryPickerModalMobile from './components/mobile/CategoryPicker.modal';
import { useCategoryQuery } from '../queries';
import Tooltip from 'components/Tooltip/Tooltip';
import './categories.scss';

export type Props = {
    onSelectChange: (value?: Category) => void;
    value?: Category;
    emptyMessage?: string;
    error?: string;
}
const SaleorCategories: React.FC<Props> = ({
    onSelectChange,
    value: _value,
    emptyMessage,
    error
}) => {
    const { data: { pages: [value] = [] } = {} } = useCategoryQuery(_value?.id);
    const { t } = useTranslation(['translation', 'product']);
    const { open, close, isOpen } = useOpen(false);
    const isDesktop = useMediaQuery(`(min-width:${BREAKPOINTS.m} )`);

    const modalProps = {
        open: isOpen,
        close,
        onSelect: onSelectChange,
        value: value?.category as Category
    }
    console.log('cats', { error })
    return <div className="categories">
        {value?.category &&
            <Spacer margin={[6, 0, 8]} key={value?.category?.id ?? _value?.id}>
                <CategoryBranch category={value?.category as Category} />
            </Spacer>
        }

        {Array.isArray(value?.category) && (
            <Spacer className="bg-secondary" padding={4} tag="p" marginBottom={6}>
                {t('product:categories.legacyHint')}
            </Spacer>
        )}

        {!value?.category && (
            <Spacer tag="p" className="categories__empty" margin={[2, 0, 4]}>
                {emptyMessage ?? t('product:categories.empty')}
            </Spacer>
        )}
        <Tooltip content={error ?? ''} isOpen={!!error} arrow={false}
            padding={'0px 0.4rem !important'}
            tipContentClassName='error--tooltip'
            direction='down-start'
        >
            <button
                type={"button"}
                className={`caption--primary categories__button ${error ? 'error' : ''}`}
                onClick={open}
            >
                {t('product:categories.button')}
            </button>
        </Tooltip>
        {
            isDesktop
                ? <CategoryPickerModalDesktop {...modalProps} />
                : <CategoryPickerModalMobile {...modalProps} />
        }
    </div >
}
export default SaleorCategories